// extracted by mini-css-extract-plugin
module.exports = {"hasLink":"styles_hasLink__3K5bb","bgImage":"styles_bgImage__1scde"};